import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Card from '@/components/Card.vue'
import Wifi from '@/components/Wifi.vue'
import WifiCard from '@/components/WifiCard.vue'
import LeaveCard from '@/components/LeaveCard.vue'
import NoticeSet from '@/components/NoticeSet.vue'
import RecordCard from '@/components/RecordCard.vue'
import Redirect from '@/components/Redirect.vue'
import PatchCard from '@/components/PatchCard.vue'

import employee_attendance from '@/components/employee_attendance.vue'
import employee_dayoff_List from '@/components/employee_dayoff_List.vue'
import employee_index from '@/components/employee_index.vue'
import employee_shift_detail from '@/components/employee_shift_detail.vue'

import iMap from '@/components/Map.vue'
import test from '@/components/test.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:tax/',
    name: 'Home',
    component: Home
  },
  {
    path: '/:tax/employee_attendance',
    name: 'employee_attendance',
    component: employee_attendance
  },
  {
    path: '/:tax/employee_dayoff_List',
    name: 'employee_dayoff_List',
    component: employee_dayoff_List
  },
  {
    path: '/:tax/employee_index',
    name: 'employee_index',
    component: employee_index
  },
  {
    path: '/:tax/employee_shift_detail',
    name: 'employee_shift_detail',
    component: employee_shift_detail
  },
  {
    path: '/:tax/noticeSet',
    name: 'NoticeSet',
    component: NoticeSet
  },
  {
    path: '/:tax/wifiCard',
    name: 'WifiCard',
    component: WifiCard
  },
  {
    path: '/:tax/leaveCard',
    name: 'leaveCard',
    component: LeaveCard
  },
  {
    path: '/:tax/redirect',
    name: 'Redirect',
    component: Redirect
  },
  {
    path: '/:tax/recordCard',
    name: 'RecordCard',
    component: RecordCard
  },
  {
    path: '/:tax/patchcard',
    name: 'PatchCard',
    component: PatchCard
  },
  {
    path: '/:tax/wifi',
    name: 'Wifi',
    component: Wifi
  },
  {
    path: '/:tax/card',
    name: 'Card',
    component: Card
  },
  {
    path: '/:tax/map',
    name: 'Map',
    component: iMap
  },
  {
    path: '/:tax/test',
    name: 'test',
    component: test
  },
  {
    path: '/:tax/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode:'history',
  routes
})

export default router
